import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { uploadContinuationHref } from '../../lib/publicUploadJourney';

export default function PublicUploadContinuation({ continuation }) {
  const href = uploadContinuationHref(continuation);
  if (!href) return null;
  return (
    <div className="space-y-3 border-t border-slate-200 pt-5" data-testid="upload-portal-continuation">
      <p className="text-sm text-slate-600">
        You can finish here, or open CareOps to see your saved progress and any remaining application, onboarding or staff steps.
      </p>
      <Link
        to={href}
        referrerPolicy="no-referrer"
        className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-5 py-3 font-medium text-white hover:bg-primary-hover"
      >
        Continue in CareOps
        <ArrowRight className="h-4 w-4" />
      </Link>
      <p className="text-xs text-slate-500">
        Sign in with your own email. Your upload stays saved; review and approval are separate steps.
      </p>
    </div>
  );
}
